<template>
  <div>
    <el-dialog
        title="密码修改"
        :visible.sync="showDialog"
        :width=dialogWidth
        :before-close="closeDialog"
        center>
      <div>
        <el-form :model="resetPassForm" label-width="70px" class="demo-ruleForm" size="mini" :rules="resetPassRule"
                 ref="resetPassForm">
          <el-form-item label="原密码" prop="pass">
            <el-input v-model="resetPassForm.pass" type="password" placeholder="请输入原密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_pass">
            <el-input v-model="resetPassForm.new_pass" type="password" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="tow_new_pass">
            <el-input v-model="resetPassForm.tow_new_pass" type="password" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-button size="mini" type="warning" @click="handleSubmit('resetPassForm')" class="bind_btn">修改</el-button>
          <div class="placehold"></div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ScreenMixins from '@/mixins/ScreenMixins';
import Message from '@/mixins/Message';
import {txPostRequest} from "@/plugins/request";

export default {
  name: 'ResetPass',
  props: ['show'],
  mixins: [ScreenMixins, Message],
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6 || value.length > 32) {
        callback(new Error('密码只允许6-32个字符'));
      } else {
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.resetPassForm.new_pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogWidth: "50%",
      resetPassForm: {
        pass: '',
        new_pass: '',
        tow_new_pass: '',
      },
      resetPassRule: {
        pass: [
          {validator: validatePassword, trigger: 'blur'}
        ],
        new_pass: [
          {validator: validatePassword, trigger: 'blur'}
        ],
        tow_new_pass: [
          {validator: validatePass2, trigger: 'blur'}
        ]
      },
    };
  },
  computed: {
    showDialog() {
      return this.handleDialog()
    }
  },
  methods: {
    handleSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          await txPostRequest('/user/change_password', {
            password: this.resetPassForm.pass,
            password2: this.resetPassForm.new_pass
          })
          this.successMessage('修改成功')
          // axios.post('/user/change_password',{
          //   password: this.resetPassForm.pass,
          //   password2 :  this.resetPassForm.new_pass
          // }, {
          //   headers: {
          //     'Content-Type': 'application/json'
          //   }
          // }).then((res)=>{
          //   let dat=res.data
          //   console.log(dat)
          //   if (dat.code===0){
          //     this.successMessage('修改成功')
          //   }else {
          //     this.errorMessage(dat.message)
          //   }
          // }).catch(err=>{
          //   console.log(err)
          //   let rep = err.response.data
          //   this.errorMessage(rep.message)
          // })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeDialog() {
      this.$emit('child-pass', false);
      this.resetPassForm = {
        pass: '',
        new_pass: '',
        tow_new_pass: '',
      }
    },
    handleDialog() {
      this.updateDialogWidth();
      window.addEventListener('resize', this.updateDialogWidth);
      return !!this.show
    },
  },

  mounted() {
  }
};
</script>

<style scoped>
.bind_btn {
  position: absolute;
  left: 42%;
  margin-bottom: 24px;
}

.placehold {
  margin: 150px 0;
}

.el-dialog__wrapper >>> .el-dialog__body {
  display: flex;
  justify-content: center;
}
</style>
